import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import classNames from 'classnames'

import { useTranslation } from '../../../../utils/providers'
import { InlineButton } from '../../../index'

const PasswordConfirm = ({
  confirmId: id,
  className,
  data,
  confirmValue,
  onChange,
  readOnly,
  disabled,
}) => {
  const [value, setValue] = useState(data?.value || '')
  const [hasFocus, setFocus] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)
  const { t } = useTranslation()

  const handleChange = (event) => {
    const v = event.target.value
    setValue(v)
    onChange(event)
  }

  const getErrorMsg = (value) => {
    let error = null
    if (confirmValue !== value) {
      error = t('FORM_ERROR_NOT_SAME_PASSWORDS')
    }
    return error
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  const inputType = passwordVisible ? 'text' : 'password'
  const currentError = getErrorMsg(value)
  const errorMessage = currentError ? (
    <div className="error-message show">
      <span>{currentError}</span>
    </div>
  ) : null

  const groupClasses = classNames('md-input-group mb-3', className, {
    error: !!currentError,
  })
  const labelClass = classNames({
    'float-above': value || hasFocus,
  })

  const showHideClasses = classNames('show-hide-password', {
    show: passwordVisible && !currentError,
  })
  const showHideStyles = currentError || !value ? null : { display: 'inline' }
  const buttonTitle = passwordVisible
    ? t('FORM_HIDE_PASSWORD')
    : t('FORM_SHOW_PASSWORD')

  return (
    <div className={groupClasses}>
      <input
        type={inputType}
        className="form-control confirm-password confirm-password-d"
        onChange={handleChange}
        name={data.name}
        id={id}
        value={value || ''}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        spellCheck={false}
        readOnly={readOnly}
        disabled={disabled}
      />
      <div className="label-box">
        <label className={labelClass} htmlFor={id}>
          {t('FORM_LABEL_PASSWORD_CONFIRM')}
        </label>
      </div>
      <InlineButton
        className={showHideClasses}
        style={showHideStyles}
        onClick={togglePasswordVisibility}
        title={buttonTitle}
        aria-label={buttonTitle}
      />
      {errorMessage}
    </div>
  )
}

PasswordConfirm.propTypes = {
  confirmId: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  confirmValue: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default PasswordConfirm
